// Schema.org protocol identifiers are fixed tokens, not copy for translation.
export const FAQ_SCHEMA = {
  context: "https://schema.org",
  pageType: String.raw`FAQPage`,
  questionType: String.raw`Question`,
  answerType: String.raw`Answer`,
} as const;
